import { render, staticRenderFns } from "./TmsQuotes.vue?vue&type=template&id=d495bec4&lang=pug&"
import script from "./TmsQuotes.vue?vue&type=script&lang=js&"
export * from "./TmsQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports